import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SendOutlineSVG = function SendOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.5 2.56a2 2 0 00-1.99-.53L3.38 8.93a2 2 0 00-.56 3.58l9.2 6.13.81.54.54.92 5.22 8.95a1.98 1.98 0 001.72 1 1.62 1.62 0 00.22-.02 2 2 0 001.7-1.38l7.73-24.08a2 2 0 00-.47-2zm-9.18 25.5a.01.01 0 000-.02l-5.49-9.4 5.46-5.45a1 1 0 00-1.42-1.42l-5.42 5.42-9.52-6.34 24.13-6.89z"
  }));
};
SendOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SendOutlineSVG);